/* ==========================================================================
   ICEMAN — comportamento da página congelada
   Carregado só no template product.iceman (via a seção ice-skin).
   ========================================================================== */
(function () {
  if (window.__iceInit) return;
  window.__iceInit = 1;

  var root = document.documentElement;
  if (!root.classList.contains('ice-page')) return;

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 1. Entrada em cena (scroll reveal) ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.ice-reveal');
    if (!els.length) return;
    if (reduced || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- 2. Neve ---------- */
  function initSnow() {
    var box = document.querySelector('[data-ice-snow]');
    if (!box || reduced) return;
    var n = window.innerWidth < 750 ? 14 : 26;
    var frag = document.createDocumentFragment();
    for (var i = 0; i < n; i++) {
      var f = document.createElement('span');
      var size = 2 + Math.random() * 4;
      f.className = 'ice-flake';
      f.style.left = (Math.random() * 100).toFixed(2) + '%';
      f.style.width = size.toFixed(1) + 'px';
      f.style.height = size.toFixed(1) + 'px';
      f.style.setProperty('--x', (Math.random() * 160 - 80).toFixed(0) + 'px');
      f.style.setProperty('--o', (0.25 + Math.random() * 0.45).toFixed(2));
      f.style.animationDuration = (11 + Math.random() * 16).toFixed(1) + 's';
      f.style.animationDelay = (-Math.random() * 20).toFixed(1) + 's';
      frag.appendChild(f);
    }
    box.appendChild(frag);
  }

  /* ---------- 3. Estilhaços de gelo ---------- */
  function burst(host, count) {
    if (reduced || !host) return;
    var n = count || 8;
    for (var i = 0; i < n; i++) {
      var s = document.createElement('i');
      var a = (Math.PI * 2 * i) / n + Math.random() * 0.5;
      var d = 26 + Math.random() * 34;
      s.className = 'ice-shard';
      s.style.setProperty('--dx', (Math.cos(a) * d).toFixed(1) + 'px');
      s.style.setProperty('--dy', (Math.sin(a) * d).toFixed(1) + 'px');
      s.style.setProperty('--dr', (Math.random() * 360).toFixed(0) + 'deg');
      host.appendChild(s);
      (function (el) { setTimeout(function () { el.remove(); }, 750); })(s);
    }
  }

  /* ---------- 4. Botões de tamanho da PDP ---------- */
  function initSizes() {
    var box = document.querySelector('.pdp__sizes');
    if (!box) return;

    function mark(label) {
      box.querySelectorAll('.pdp__size').forEach(function (l) {
        l.classList.toggle('is-picked', l === label);
      });
    }

    // estado inicial (a PDP já vem com um tamanho marcado)
    var checked = box.querySelector('input:checked');
    if (checked) mark(checked.closest('.pdp__size'));

    box.addEventListener('change', function (e) {
      var input = e.target.closest('input[type="radio"]');
      if (!input) return;
      var label = input.closest('.pdp__size');
      if (!label) return;
      mark(label);
      burst(label, 8);
    });
  }

  /* ---------- 5. Bloco de gelo do hero: arraste pra descongelar ---------- */
  function initSlab() {
    var slab = document.querySelector('[data-ice-slab]');
    if (!slab) return;
    var frost = slab.querySelector('.ice-slab__frost');
    if (!frost || reduced) { if (frost) slab.classList.add('is-clear'); return; }

    var r = 0;
    var refrost = null;

    function move(x, y) {
      var box = slab.getBoundingClientRect();
      frost.style.setProperty('--mx', (x - box.left).toFixed(0) + 'px');
      frost.style.setProperty('--my', (y - box.top).toFixed(0) + 'px');
      r = Math.min(r + 6, 190);
      frost.style.setProperty('--mr', r + 'px');
      if (r > 150) slab.classList.add('is-clear');
      clearTimeout(refrost);
      refrost = setTimeout(function () {
        if (slab.classList.contains('is-clear')) return;
        r = 0;
        frost.style.setProperty('--mr', '0px');
      }, 2600);
    }

    // se ninguém encostar, o gelo derrete sozinho — a camisa nunca fica escondida
    setTimeout(function () { slab.classList.add('is-clear'); }, 2200);

    slab.addEventListener('pointermove', function (e) { move(e.clientX, e.clientY); });
    slab.addEventListener('touchmove', function (e) {
      var t = e.touches[0];
      if (t) move(t.clientX, t.clientY);
    }, { passive: true });
    slab.addEventListener('click', function () { slab.classList.add('is-clear'); });
  }

  /* ---------- 6. Upsell: quick add + medidor leve 3 pague 2 ---------- */
  function initUpsell() {
    var sec = document.querySelector('[data-ice-up]');
    if (!sec) return;

    var meter = sec.querySelector('[data-ice-meter]');
    var deny = (sec.getAttribute('data-deny') || '').split(',').filter(Boolean);
    var tiers = (sec.getAttribute('data-tiers') || '3,5,7,9').split(',').map(Number);

    function eligible(cart) {
      var n = 0;
      (cart.items || []).forEach(function (it) {
        var hay = ((it.product_title || '') + ' ' + (it.handle || '')).toLowerCase();
        for (var i = 0; i < deny.length; i++) {
          if (deny[i] && hay.indexOf(deny[i]) !== -1) return;
        }
        n += it.quantity || 0;
      });
      return n;
    }

    function paint(count) {
      if (!meter) return;
      var target = tiers[tiers.length - 1];
      var maxed = true;
      for (var i = 0; i < tiers.length; i++) {
        if (count < tiers[i]) { target = tiers[i]; maxed = false; break; }
      }
      var pay = Math.ceil(target / 2);
      var free = target - pay;
      var filled = Math.min(count, target);
      var rem = Math.max(target - count, 0);

      var msg = meter.querySelector('[data-ice-meter-msg]');
      if (msg) {
        var tpl = maxed ? meter.getAttribute('data-msg-max') : meter.getAttribute('data-msg-add');
        msg.innerHTML = (tpl || '')
          .replace('[rem]', '<b>' + rem + '</b>')
          .replace('[free]', '<b>' + free + '</b>')
          .replace('[target]', '<b>' + target + '</b>');
      }

      var pips = meter.querySelector('[data-ice-meter-pips]');
      if (pips) {
        var svg = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M8.5 3 5 5.5 3.2 8.8l2.3 1.5.5-.8V21h12V9.5l.5.8 2.3-1.5L19 5.5 15.5 3l-1.4 1.6a3 3 0 0 1-4.2 0L8.5 3Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>';
        var html = '';
        for (var j = 1; j <= target; j++) {
          html += '<span class="ice-meter__pip' + (j <= filled ? ' is-filled' : '') + '">' + svg + '</span>';
        }
        pips.innerHTML = html;
      }

      var fill = meter.querySelector('[data-ice-meter-fill]');
      if (fill) fill.style.width = Math.round((filled / target) * 100) + '%';
    }

    function refresh() {
      fetch(window.Shopify.routes.root + 'cart.js')
        .then(function (r) { return r.json(); })
        .then(function (c) { paint(eligible(c)); })
        .catch(function () {});
    }

    // pinta o estado inicial (o Liquid já renderizou, isto só garante a barra animada)
    if (meter) {
      var start = parseInt(meter.getAttribute('data-count'), 10) || 0;
      requestAnimationFrame(function () { paint(start); });
    }

    sec.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-ice-add]');
      if (toggle) {
        var card = toggle.closest('.ice-card');
        var wasOpen = card.classList.contains('is-open');
        sec.querySelectorAll('.ice-card.is-open').forEach(function (c) { c.classList.remove('is-open'); });
        if (!wasOpen) card.classList.add('is-open');
        return;
      }

      var chip = e.target.closest('[data-ice-var]');
      if (!chip || chip.disabled) return;
      var card2 = chip.closest('.ice-card');
      var id = chip.getAttribute('data-ice-var');
      chip.disabled = true;
      chip.style.position = 'relative';
      burst(chip, 6);

      var done = function () {
        chip.disabled = false;
        card2.classList.remove('is-open');
        card2.classList.add('is-added');
        var btn = card2.querySelector('[data-ice-add]');
        if (btn) {
          var old = btn.getAttribute('data-label') || btn.textContent;
          btn.setAttribute('data-label', old);
          btn.textContent = btn.getAttribute('data-added-label') || 'In the bag';
          setTimeout(function () {
            btn.textContent = old;
            card2.classList.remove('is-added');
          }, 2600);
        }
        refresh();
      };

      if (window.MatchdayCart && window.MatchdayCart.addAndOpen) {
        window.MatchdayCart.addAndOpen([{ id: id, quantity: 1 }]).then(done);
      } else {
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
        }).then(done).catch(done);
      }
    });

    // se o cliente adicionar pela PDP padrão, o medidor acompanha
    document.addEventListener('submit', function (e) {
      if (e.target && e.target.classList && e.target.classList.contains('pdp__form')) {
        setTimeout(refresh, 1200);
      }
    });
  }

  /* ---------- 7. Cromo da loja: logo e barra de aviso só desta página ---------- */
  function initChrome() {
    var skin = document.querySelector('[data-ice-skin]');
    if (!skin) return;

    // logo alternativo
    var logo = (skin.getAttribute('data-logo') || '').trim();
    if (logo) {
      var box = document.querySelector('.mdhdr__logo');
      if (box) {
        var img = box.querySelector('img');
        if (!img) {
          img = document.createElement('img');
          var txt = box.querySelector('.mdhdr__logo-text');
          if (txt) txt.remove();
          box.insertBefore(img, box.firstChild);
        }
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.src = logo;
        var h = parseInt(skin.getAttribute('data-logo-h'), 10);
        if (h) {
          img.style.height = h + 'px';
          img.style.width = 'auto';
        }
      }
    } else {
      var box0 = document.querySelector(".mdhdr__logo");
      if (box0) box0.classList.add("ice-logo-fallback");
    }

    // mensagens da barra de aviso (mantém o carrossel do tema girando)
    var raw = (skin.getAttribute('data-ann') || '').trim();
    if (raw) {
      var msgs = raw.split('||').map(function (m) { return m.trim(); }).filter(Boolean);
      if (msgs.length) {
        var slides = document.querySelectorAll('announcement-bar .announcement__slide');
        slides.forEach(function (s, i) {
          var t = s.querySelector('.announcement__text span') || s.querySelector('.announcement__text');
          if (t) t.textContent = msgs[i % msgs.length];
        });
      }
    }
  }


  function boot() {
    initChrome();
    initReveal();
    initSnow();
    initSizes();
    initSlab();
    initUpsell();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
